import { motion } from 'framer-motion';

const reasons = [
  {
    title: 'AI-Native Enterprise Transition',
    desc: 'Organisations that structurally integrate intelligence into operations — rather than bolting on tools — will define the next era of commercial resilience.',
  },
  {
    title: 'Organisational Intelligence Restructuring',
    desc: 'Legacy decision structures were not designed for the speed, complexity, or ambiguity of AI-augmented markets. They require architectural redesign.',
  },
  {
    title: 'Operational Resilience',
    desc: 'Volatility, regulatory shifts, and technological disruption demand systems that adapt continuously — not strategies that assume stability.',
  },
  {
    title: 'Strategic AI Readiness',
    desc: 'Most organisations do not yet understand where AI creates durable leverage, what infrastructure they require, or how to evolve safely and strategically.',
  },
];

const WhyThisMatters = () => {
  return (
    <section className="relative py-16 lg:py-20" data-testid="why-this-matters">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <p className="text-xs uppercase tracking-[0.3em] mb-3" style={{ color: 'rgba(201,162,39,0.5)' }}>
            The Imperative
          </p>
          <h3
            className="text-xl md:text-2xl font-light tracking-[0.1em] text-white"
            style={{ fontFamily: "'Cinzel', serif" }}
          >
            Why This Matters Now
          </h3>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
          {reasons.map((r, i) => (
            <motion.div
              key={r.title}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="p-6"
              style={{
                background: 'rgba(10,22,40,0.3)',
                border: '1px solid rgba(201,162,39,0.08)',
                borderRadius: '4px',
              }}
              data-testid={`why-matters-${i + 1}`}
            >
              <h4
                className="text-xs uppercase tracking-[0.15em] mb-3"
                style={{ color: '#c9a227', fontFamily: "'Cinzel', serif" }}
              >
                {r.title}
              </h4>
              <p className="text-sm leading-relaxed" style={{ color: 'rgba(255,255,255,0.5)' }}>
                {r.desc}
              </p>
            </motion.div>
          ))}
        </div>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="text-center mt-10 text-sm italic max-w-2xl mx-auto"
          style={{ color: 'rgba(201,162,39,0.5)', fontFamily: "'Cormorant Garamond', serif" }}
        >
          The next competitive advantage will not belong to organisations that merely use AI — but to those structurally designed to evolve with it.
        </motion.p>
      </div>
    </section>
  );
};

export default WhyThisMatters;
